import $ from 'jquery';
import Popper from 'popper.js';
import branchBar from './modules/branch-bar';

// Bootstrap (v3) doesn't have proper module support, so we need to make jQuery global and `require` bootstrap
global.$ = global.jQuery = $;
global.Popper = Popper;
require('bootstrap');
require('slick-carousel');

import Svg4everybody from 'Svg4everybody'; // for <use xlink:href> support within IE

// Custom modules
import helper from './modules/helper';
import FormHelper from './modules/form-helper';
import carSearch from './modules/car-search';
import auction from './modules/auction';
import toggleDropdown from './modules/toggle-dropdown';
import auctionLifts from './modules/auction-lifts';
import carousel from './modules/carousel';
import lazy from './modules/lazy';
import customSelect from './modules/custom-select';
import footerToBottom from './modules/footer-to-bottom';
import accordionTab from './modules/accordion-tab';
import showImages from './modules/show-images';
import priceWatch from './modules/price-watch';
import login from './modules/login';
import checkout from './modules/checkout';

//Check if element is in viewport
$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// Polyfill for IE matches
if(!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

//Initialize everything on document ready
$(document).ready(() => {
  Svg4everybody();

  branchBar.init();
  login.init();
  helper.init();
  new FormHelper().init();
  carSearch.init();
  auctionLifts.init();
  auction.init();
  carousel.init();
  customSelect.init();
  lazy.init();
  showImages.init();
  priceWatch.init();
  checkout.init();
  accordionTab.init();
  footerToBottom.init();
  toggleDropdown.init();
});
